module.exports = __webpack_public_path__ + "static/img/home_img.28ab84c8.png";